import { JsonObject, JsonProperty } from 'json2typescript'
import Model from './Model'

@JsonObject('ReInsurerDocument')
export default class ReInsurerDocument extends Model {
  @JsonProperty('name', String)
  name = ''

  @JsonProperty('path', String)
  path: string = ''
}
